module.exports = __webpack_public_path__ + "static/media/18.dca279ed.jpg";